var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ChartPlotly",
    _vm._g(
      {
        attrs: {
          data: _vm.data,
          layout: _vm.computedLayout,
          toImageButtonOptions: _vm.toImageButtonOptions,
        },
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }